import { Control } from "react-hook-form";
import { ChangeCustomerEmployeePasswordProps } from "~/application/usecases/CustomerEmployee/ICustomerEmployeeService";
import { BiztripLogo } from "~/components/BiztripLogo";
import { Box } from "~/components/Box";
import { Button } from "~/components/Button";
import { Flex } from "~/components/Flex";
import { Form } from "~/components/Form";
import { FieldLabel, FormControl } from "~/components/FormControl";
import { PasswordInput, TextInput } from "~/components/Input";
import { Text } from "~/components/Text";
import { Label } from "~/components/Typography";
import { styled } from "~/application/theme";
import { Topography } from "~/components/Topography";

const PageContainer = styled("div", {
  width: "100vw",
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#ffffff",
  position: "relative",
  overflow: "hidden",
  padding: "$4",
});

const BackgroundWrapper = styled("div", {
  position: "absolute",
  inset: 0,
  zIndex: 0,
});

const CardContainer = styled("div", {
  backgroundColor: "$neutrals-white",
  borderRadius: "$mdlg",
  boxShadow: "0 4px 32px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04)",
  width: "100%",
  maxWidth: "480px",
  padding: "$12 $12",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "$6",
  position: "relative",
  zIndex: 1,
  "@mxsm": {
    padding: "$8 $6",
    maxWidth: "100%",
  },
});

export interface ChangeCustomerEmployeePasswordContainerProps {
  control: Control<ChangeCustomerEmployeePasswordProps, any>;
  isSubmitting: boolean;
  showSecretKeyInput: boolean;
  onSubmit: () => void;
}

export function ChangePasswordContainer({
  isSubmitting,
  control,
  showSecretKeyInput,
  onSubmit,
}: ChangeCustomerEmployeePasswordContainerProps) {
  return (
    <PageContainer>
      <BackgroundWrapper>
        <Topography lowColor="#3B82F6" midColor="#3B82F6" highColor="#ffffff" scale={2} />
      </BackgroundWrapper>

      <CardContainer>
        <Flex direction="column" align="center" gap="2" css={{ mb: "$2", width: "100%" }}>
          <BiztripLogo size="lg" css={{ mb: "$2" }} />
          <Text as="h1" size="6" css={{ fw: "700", color: "$neutrals-darkest", textAlign: "center" }}>
            Alterar Senha
          </Text>
        </Flex>

        <Form onSubmit={onSubmit} style={{ width: "100%" }}>
          <Flex direction="column" gap="4" css={{ width: "100%" }}>
            <FormControl name="password" control={control} required>
              <FieldLabel>Nova senha</FieldLabel>
              <PasswordInput />
            </FormControl>

            <FormControl
              name="confirmedPassword"
              control={control}
              required
            >
              <FieldLabel>Confirmação da nova senha</FieldLabel>
              <PasswordInput />
            </FormControl>

            {showSecretKeyInput && (
              <Box css={{ mb: "$2" }}>
                <FormControl name="secretKey" control={control} required>
                  <FieldLabel>Código de segurança</FieldLabel>
                  <TextInput />
                </FormControl>
                <Label size="3" css={{ display: "block", mt: "$2", lineHeight: 1.25, color: "$neutral-600" }}>
                  Insira o código de segurança gerado pelo aplicativo Google Authenticator para continuar
                </Label>
              </Box>
            )}

            <Button type="submit" disabled={isSubmitting} variant="primary" size="mdl" rounded fullWidth css={{ fontSize: "$md", fontWeight: 600, mt: "$2" }}>
              Alterar senha
            </Button>
          </Flex>
        </Form>
      </CardContainer>
    </PageContainer>
  );
}
